// Built-in shaders only: packages supply validated settings and image paths.
export const waterVertexShader = `
attribute vec2 position;
varying vec2 uv;
void main() {
  uv = position * 0.5 + 0.5;
  gl_Position = vec4(position, 0.0, 1.0);
}`

export const waterFragmentShader = `
precision mediump float;
varying vec2 uv;
uniform sampler2D artwork;
uniform sampler2D waterMask;
uniform vec2 resolution;
uniform vec2 imageSize;
uniform float time;
uniform float strength;
uniform float shimmer;
void main() {
  // Match an image with object-fit: cover at every viewport aspect ratio.
  vec2 crop = min(vec2(1.0), vec2(resolution.x / resolution.y / (imageSize.x / imageSize.y),
    (imageSize.x / imageSize.y) / (resolution.x / resolution.y)));
  vec2 p = (uv - 0.5) * crop + 0.5;
  float mask = texture2D(waterMask, p).r;
  float wave = sin(p.y * 165.0 + p.x * 23.0 - time * 1.7);
  float smallWave = sin(p.y * 285.0 - p.x * 31.0 - time * 2.3);
  vec2 shift = vec2(wave + smallWave * 0.35, sin(p.x * 65.0 + time * 0.8) * 0.25)
    * strength / imageSize * mask;
  vec2 warped = clamp(p + shift, vec2(0.0), vec2(1.0));
  // Avoid pulling bank/rock pixels across the edge of the mask.
  float amount = min(mask, texture2D(waterMask, warped).r);
  vec4 base = texture2D(artwork, p);
  vec4 water = texture2D(artwork, warped);
  water.rgb += wave * smallWave * shimmer;
  gl_FragColor = mix(base, water, amount);
}`
